import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface CreateBusinessUnitRelationRequest {
  actionName: 'createBusinessUnitRelationRequest';
  request: mtechnavi.api.company.IBusinessUnitRelationRequest;
}

export const createBusinessUnitRelationRequest = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IBusinessUnitRelationRequest
) => {
  const execMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/CreateBusinessUnitRelationRequest';

  return await worker.invokeListRequest(execMethodName, {
    businessUnitRelationRequest: {
      businessUnitRelationRequestId: req.businessUnitRelationRequestId,
      recipient: req.recipient,
      contact: req.contact,
      contactDepartment: req.contactDepartment,
      message: req.message,
      contactInformationMessage: req.contactInformationMessage,
    },
  });
};
